<template>
  <div class="shadow-box">
    <h6 class="section-title mb-2">Case data</h6>

    <div v-if="!fetched" class="d-flex justify-content-start">
      <button
        type="button"
        class="btn btn-warning btn-sm"
        :disabled="loading"
        data-test="examination-case-data-toggle"
        @click="fetchRaw"
      >
        <span
          v-if="loading"
          class="spinner-border spinner-border-sm me-2"
          role="status"
          aria-hidden="true"
        ></span>
        <span v-if="loading">Fetching…</span>
        <span v-else
          >View case data • Access is logged because it contains patient
          information</span
        >
      </button>
    </div>

    <div v-else>
      <div v-if="error" class="text-danger small mb-2">{{ error }}</div>
      <pre
        class="payload mb-2"
        data-test="examination-case-data-payload"
      ><code>{{ prettyJson }}</code></pre>
      <button
        type="button"
        class="btn btn-outline-secondary btn-sm"
        @click="hide"
      >
        Hide case data
      </button>
    </div>
  </div>
</template>

<script>
import { practitionerHttpService } from "../../../../app/practitioner-portal/store/practitioner-http-service";

export default {
  name: "ExaminationCaseDataBox",
  props: { examinationId: { type: [String, Number], required: true } },
  data() {
    return { loading: false, error: "", fetched: false, payload: {} };
  },
  computed: {
    prettyJson() {
      try {
        return JSON.stringify(this.payload ?? {}, null, 2);
      } catch (e) {
        return "";
      }
    },
  },
  methods: {
    fetchRaw() {
      this.loading = true;
      this.error = "";
      practitionerHttpService
        .get(
          `/api/internal/admin/logs/examinations/${this.examinationId}/raw-case-data`,
        )
        .then((res) => {
          this.payload =
            res && typeof res === "object" && "data" in res ? res.data : res;
          this.fetched = true;
          this.loading = false;
        })
        .catch((err) => {
          this.loading = false;
          this.error = err?.message || "Failed to fetch case data";
          if (this.userErrorMessage) this.userErrorMessage(err);
        });
    },
    hide() {
      this.fetched = false;
      this.payload = {};
    },
  },
};
</script>

<style scoped>
.section-title {
  font-weight: 600;
  font-size: 0.95rem;
  color: #212529;
}
.payload {
  background: #0f172a;
  color: #e2e8f0;
  border-radius: 0.375rem;
  padding: 0.75rem 1rem;
  max-height: 50vh;
  overflow: auto;
  font-size: 0.825rem;
  margin: 0;
}
</style>
